import axios from 'axios';
import apiClient, { API_BASE_URL } from '@/lib/api-client';

export interface TemplateLeadInput {
  email: string;
  template: string;
  /** Cloudflare Turnstile token */
  token: string;
  /** honeypot: always '' from a person */
  website: string;
  /** Where the form sits: 'funnel' on the ad landing pages (left out on the template pages). */
  page?: string;
  /** Ad source, each at most 100 characters (readUtm in src/marketing/funnel.ts); the endpoint ignores fields it does not store yet. */
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
}

/**
 * The call goes through its OWN axios instance, like the unsubscribe calls: no bearer from the session cookie (a signed-in owner whose plan lapsed would
 * otherwise get a 403 subscription_required and the read-only banner events), no cross-site credentials, no refresh-and-redirect on a 401. The page is
 * public marketing. The adapter is the app's, so the dev mock and the tests answer it. Created per call so the adapter is read when it is used.
 */
const publicClient = () =>
  axios.create({ baseURL: API_BASE_URL, adapter: apiClient.defaults.adapter, withCredentials: false, headers: { Accept: 'application/json', 'Content-Type': 'application/json' } });

/**
 * Asks for the editable Google Sheet by email. The server answers 202 for every accepted or ignored submission (it never says whether an address is
 * known); a failure is thrown as the axios error, for the form to word.
 */
export async function submitTemplateLead(input: TemplateLeadInput): Promise<{ ok: true }> {
  await publicClient().post('/v1/public/template-leads', input);
  return { ok: true };
}
